import { useCallback, useEffect } from 'react';
import { TrackingPayload } from '../types';
import { useTimePickerData } from './useTimePickerData';
import { useTrackComponentEvent } from './useTrackComponentEvent';

export const useAnalytics = (
  data: ReturnType<typeof useTimePickerData>,
  timeOptions: any[],
  isMessageOwner?: boolean
) => {
  const { bookingBoatId, bookingDuration, tripStartFormatted } = data;
  const trackComponentEvent = useTrackComponentEvent();

  const trackAvailableTimes = useCallback(() => {
    const payload: TrackingPayload = {
      trip_date: tripStartFormatted,
      duration: bookingDuration?.label,
      boat_public_id: bookingBoatId,
      available_times_grid: Object.fromEntries(timeOptions.map((option) => [option.value, option.available])),
    };

    trackComponentEvent({
      event_name: 'show',
      component_type: 'group_of_controls',
      object: 'booking_widget',
      context: 'booking_widget',
      object_properties: payload,
    });
  }, [bookingBoatId, bookingDuration, timeOptions, tripStartFormatted, trackComponentEvent]);

  useEffect(() => {
    if (timeOptions.length > 0 && !isMessageOwner) {
      trackAvailableTimes();
    }
  }, [timeOptions, trackAvailableTimes]);

  return { trackAvailableTimes };
};
